import BaseDataStore from '@/components/base/store/BaseDataStoreV1'
import i18n from '@/plugins/i18n'

const BaseConst = {
  version: 1,
  storeName: 'C1001ProjectCrowdFund',
  serviceName: 'C1001ProjectCrowdFundService',
  storeConst: {
    ACTION: {
      getHint: {
        store: 'M3901Guide/getHint'
      }
    }
  },
  componentDef: {
    form: {
      viewDef: [
        {
          column: 'col-12',
          data: 'project_funding_target',
          custom: 'C0101ProjectFundingTarget',
          label: i18n.t('c0101.filter.project_funding_target'),
          rules: 'required',
          class: 'required',
          props: {
            coinACurrencyList: []
          },
          async: [{
            api: 'M1902CoinsTypeCurrencyService.GetACoinCurrency',
            mutateTarget: 'props.coinACurrencyList'
          }]
        },
        {
          column: 'col-12',
          data: {
            get (val) {
              return {
                project_crowd_fund_deadline: val.project_crowd_fund_deadline ?? null,
                project_crowd_fund_deadline_day_draft: val.project_crowd_fund_deadline_day_draft ?? null
              }
            },
            set (val, input) {
              if (input.project_crowd_fund_deadline) val.project_crowd_fund_deadline = input.project_crowd_fund_deadline
              if (input.project_crowd_fund_deadline_day_draft) val.project_crowd_fund_deadline_day_draft = input.project_crowd_fund_deadline_day_draft
              return val
            }
          },
          custom: 'C1001ProjectCrowdFundDeadline'
        },
        {
          column: 'col-12',
          data: {
            get (val) {
              return {
                project_crowd_fund_tier: val.project_crowd_fund_tier,
                project_crowd_fund_item: val.project_crowd_fund_item
              }
            },
            set (val, input) {
              val.project_crowd_fund_tier = input.project_crowd_fund_tier
              val.project_crowd_fund_item = input.project_crowd_fund_item
              return val
            }
          },
          custom: 'C1101ListC1201List',
          label: i18n.t('c1001.filter.project_crowd_fund_reward')
        },
        {
          column: 'col-12',
          data: 'project_crowd_fund_policy',
          type: 'ttc_policy',
          props: {
            policyCode: 'collab.projectCrowdFund'
          }
        }
      ]
    }
  }
}
const C1001Const = new BaseDataStore(BaseConst)
export default C1001Const
